import React, { useRef, useEffect } from 'react';
import MessageBubble from './MessageBubble';
import './ChatWindow.css';

const ChatWindow = ({ messages, loading, streamingMessage }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, loading]);

  return (
    <div className="chat-window">
      {messages.length === 0 && !loading && (
        <div className="empty-state">
          <div className="empty-icon">💬</div>
          <h3>No messages yet</h3>
          <p>Start a conversation using the quick questions above or type your own message!</p>
        </div>
      )}
      
      {messages.map((msg, idx) => (
        <MessageBubble
          key={idx}
          message={msg.content}
          role={msg.role}
          timestamp={msg.timestamp}
        />
      ))}
      
      {loading && !streamingMessage && (
        <div className="typing-indicator-container">
          <div className="typing-indicator">
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
          </div>
          <span className="typing-text">AI is thinking...</span>
        </div>
      )}

      {streamingMessage && (
        <MessageBubble
          message={streamingMessage}
          role="assistant"
          timestamp={new Date().toISOString()}
        />
      )}
      
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatWindow;